import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AppContent from './components/AppContent';

// Contexts
import { ToastProvider } from './contexts/ToastContext';
import { SearchProvider } from './contexts/SearchContext';
import { DialogProvider } from './contexts/DialogContext';

/**
 * Main application component
 * Sets up the provider hierarchy for the application
 */
function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ToastProvider>
        <SearchProvider>
          <DialogProvider>
            <AppContent />
          </DialogProvider>
        </SearchProvider>
      </ToastProvider>
    </LocalizationProvider>
  );
}

export default App;
